import React, { Component } from 'react';

import '../css/components/BadgeExpertise.css'
import ellipsePole from '../images/elipse-poles.png'

export default class BadgeExpertise extends Component {
	render() {
		return (
			<div className="badge-expertise">
				<div className="badge">
					<img src={ellipsePole} alt="ellipse"></img>
					<img src={this.props.src} alt={this.props.title}></img>
				</div>
				<small className="text-detail">{this.props.title}</small>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/BadgeExpertise.js